// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3InuQ","label":"LabeledBox_label__1dIUn"};